import type { OeeThresholds } from "@/hooks/useOrganizationPolicy";
import type { LineSummary } from "@/features/lines/hooks";

export const STATUS_PILL: Record<
  LineSummary["status"],
  { tone: "success" | "danger" | "warning" | "neutral"; label: string }
> = {
  RUNNING: { tone: "success", label: "Em produção" },
  STOPPED: { tone: "danger", label: "Parada" },
  PARTIAL: { tone: "warning", label: "Parcial" },
  IDLE: { tone: "neutral", label: "Ociosa" },
};

// Spec 079 — os limiares vêm da organização, como em `oee-thresholds.ts`. Eram `85`/`65` escritos
// aqui, uma TERCEIRA cópia dos mesmos números: a lista de linhas pintava a barra contra 85 enquanto
// o detalhe da linha, ao lado, já pintava contra o valor configurado pela fábrica.
export function oeeBand(
  avail: number | null,
  t: OeeThresholds
): "success" | "warning" | "danger" | "neutral" {
  if (avail === null) return "neutral";
  const pct = avail * 100;
  if (pct >= t.good) return "success";
  if (pct >= t.warn) return "warning";
  return "danger";
}

export function fakeOeeSeries(seed: number | null): number[] {
  if (seed === null) return [];
  const v = seed * 100;
  return Array.from({ length: 7 }, (_, i) => v + Math.sin(i * 1.4) * 5);
}
